import React from 'react';
import { Routes, Route } from 'react-router-dom';
import BudgetList from './BudgetList';
import BudgetForm from './BudgetForm';
import BudgetDetail from './BudgetDetail';

const Budget = () => {
  return (
    <Routes>
      <Route index element={<BudgetList />} />
      <Route path="new" element={<BudgetForm />} />
      <Route path=":id" element={<BudgetDetail />} />
      <Route path=":id/edit" element={<BudgetForm />} />
    </Routes>
  );
};

export default Budget;
